import axios from 'axios';
import { getSubscriptionStatus } from 'api/subscription';
import { SubscriptionStatus } from 'types/subscription';
import { useQuery } from '@tanstack/react-query';

const forbiddenError = (error: Error) => {
  if (axios.isAxiosError(error)) {
    return error.response?.status === 403;
  }
  return true;
};

export function useSubscriptionStatus(userId: string | undefined) {
  const queryResponse = useQuery<SubscriptionStatus>(
    ['subscription', userId],
    () => getSubscriptionStatus(userId || ''),
    {
      enabled: !!userId,
      retry: (failureCount, error) => {
        return !forbiddenError(error as Error);
      },
      staleTime: Infinity
    }
  );

  return {
    subStatus: queryResponse.data,
    subStatusLoading: queryResponse.isLoading,
    subStatusFetching: queryResponse.isFetching,
    ...queryResponse,
  };
}
